// extracted by mini-css-extract-plugin
module.exports = {"section":"fundToFund_section__1WLta","container":"fundToFund_container__9mb51","content":"fundToFund_content__7JC04","image":"fundToFund_image__l3PYe"};